import { useState } from "react";
import { Container, Col, ProgressBar, Button } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import ArrowUpImage from "../assets/arrowup.png";

const points = [
  {
    title: "Auto categorize with AI",
    desc: "AI sorts every transaction into IRS-approved categories",
  },
  {
    title: "Year-round tracking",
    desc: "Never miss a deduction with continuous monitoring",
  },
  {
    title: "CPA-ready reports",
    desc: "Export professional documentation instantly",
  },
];

// CountUp component triggered by isVisible
const CountUp = ({ end, isVisible, duration = 1 }) => {
  const [count, setCount] = useState(0);

  if (isVisible && count === 0) {
    let start = 0;
    const increment = end / (duration * 60);
    const interval = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(interval);
      } else {
        setCount(Math.floor(start));
      }
    }, 1000 / 60);
  }

  return <>{count.toLocaleString()}</>;
};

const SavingSection = () => {
  const [visible, setVisible] = useState(false);

  return (
    <section className="saving-section py-5">
      <Container>
        {/* Title & Description */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          onViewportEnter={() => setVisible(true)}
        >
          <h2 className="fw-bold display-6">
            You could be saving thousands - every year.
          </h2>
          <p className="fs-5 text-secondary mt-3">
            WriteOffGenie helps you write-off every eligible deduction you might miss- users save an average of $20,000 annually.
            <br />
            Stop overpaying and start keeping more of what you earn.
          </p>
        </motion.div>

        {/* Flex Section */}
        <div className="align-items-center g-5 mt-5 row m-0 p-0">
          {/* Left Section */}
          <Col md={6} className="m-0 p-0">
            <h5 className="fw-bold mb-3">See how much you could save</h5>
            <p className="text-secondary mb-4 saving-side-desc">
              Most freelancers and business owners miss thousands in deductions every year. Our AI helps auto categorizing the transactions and generate IRS ready reason instantly.
            </p>

            <div className="saving-points">
              {points.map((point, idx) => (
                <motion.div
                  key={idx}
                  className="d-flex align-items-start mb-3"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }} 
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.2, duration: 0.5, ease: "easeOut" }}
                >
                  <FaCheckCircle className="text-success me-3 mt-1" size={20} />
                  <div>
                    <p className="mb-1 fw-bold text-dark">{point.title}</p>
                    <p className="mb-0 text-secondary">{point.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </Col>

          {/* Right Section */}
          <Col sm={6} className="m-0 p-0">
            <motion.div
              className="deduction-card p-4 rounded-4 shadow m-3"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h5 className="text-center fw-bold mb-2">Annual Tax Deductions Comparison</h5>
              <p className="text-center text-secondary mb-4">Manual vs • With Genie</p>

              {/* Progress Bars */}
              <div className="mb-3">
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-secondary">Without Genie</span>
                  <span className="fw-bold">
                    $<CountUp end={5300} isVisible={visible} />
                  </span>
                </div>
                <ProgressBar className="progressbard-style" now={visible ? 40 : 0} variant="secondary" />
              </div>

              <div className="mb-4">
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-secondary">With Genie</span>
                  <span className="fw-bold" style={{ color: "rgba(0, 30, 61, 1)" }}>
                    $<CountUp end={20500} isVisible={visible} />
                  </span>
                </div>
                <ProgressBar now={visible ? 100 : 0} className="progressbard-style-primary" />
              </div>

              {/* Center Line */}
              <div className="my-4 mx-auto" style={{ width: "70%", height: "2px", backgroundColor: "rgba(0,0,0,0.1)" }}></div>

              {/* Bottom Button */}
              <div className="div d-flex justify-content-center">
                <Button
                  className="saving-button text-md-left d-flex align-items-center rounded-pill justify-content-between p-3 rounded-3"
                >
                  <div className="d-flex align-items-center">
                    <img alt="img" src={ArrowUpImage} className="me-3 text-success money-upimage-style" />
                    <div className="text-start">
                      <p className="mb-1 text-success money-up-style">
                        +$<CountUp end={15200} isVisible={visible} /> more saved
                      </p>
                      <small className="text-secondary">386% increase</small>
                    </div>
                  </div>
                  <span></span>
                </Button>
              </div>
            </motion.div>

            <p className="text-center text-secondary mt-3 mb-0 fs-7">
              * Average annual deductions identified by WriteOffGenie users
            </p>
          </Col>
        </div>
      </Container>
    </section>
  );
};

export default SavingSection;
